import BalanceIcon from "@mui/icons-material/Balance";
import BusinessIcon from "@mui/icons-material/Business";
import CelebrationIcon from "@mui/icons-material/Celebration";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import PublicIcon from "@mui/icons-material/Public";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import VerifiedIcon from "@mui/icons-material/Verified";
import BoltIcon from "@mui/icons-material/Bolt";

const iconByName = {
  stethoscope: MedicalServicesIcon,
  building: BusinessIcon,
  shield: HealthAndSafetyIcon,
  zap: BoltIcon,
  heart: FavoriteBorderIcon,
  award: VerifiedIcon,
  sparkles: AutoAwesomeIcon,
  door: MeetingRoomIcon,
  balance: BalanceIcon,
  party: CelebrationIcon,
  growth: TrendingUpIcon,
  globe: PublicIcon,
};

/** Devuelve el componente de icono MUI asociado a un nombre lógico. */
export const getIcon = (name) => iconByName[name] || AutoAwesomeIcon;
